var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "addUserForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                attrs: { autocomplete: "off" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.addUser($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "First Name" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "First Name",
                                vid: "FirstName",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "FirstName",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "Last Name",
                                            placeholder: "First Name",
                                          },
                                          model: {
                                            value: _vm.firstName,
                                            callback: function ($$v) {
                                              _vm.firstName = $$v
                                            },
                                            expression: "firstName",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Last Name" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Last Name",
                                vid: "LastName",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "LastName",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "Last Name",
                                            placeholder: "Last Name",
                                          },
                                          model: {
                                            value: _vm.lastName,
                                            callback: function ($$v) {
                                              _vm.lastName = $$v
                                            },
                                            expression: "lastName",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Email",
                              "label-for": "login-email",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Email",
                                vid: "email",
                                rules: "required|email",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "login-email",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "login-email",
                                            placeholder: "john@example.com",
                                            autocomplete: "off",
                                          },
                                          model: {
                                            value: _vm.email,
                                            callback: function ($$v) {
                                              _vm.email = $$v
                                            },
                                            expression: "email",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Phone Number" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required|integer",
                                name: "Number",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            state:
                                              errors.length > 0 ? false : null,
                                            placeholder: "Enter Number Only",
                                          },
                                          model: {
                                            value: _vm.phoneNumber,
                                            callback: function ($$v) {
                                              _vm.phoneNumber = $$v
                                            },
                                            expression: "phoneNumber",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Password" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required|password",
                                name: "password",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "b-input-group",
                                          {
                                            staticClass: "input-group-merge",
                                            class:
                                              errors.length > 0
                                                ? "is-invalid"
                                                : null,
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: _vm.showPassword
                                                  ? "text"
                                                  : "password",
                                                state: errors[0] ? false : null,
                                                placeholder: "Password",
                                                autocomplete: "new-password",
                                              },
                                              model: {
                                                value: _vm.password,
                                                callback: function ($$v) {
                                                  _vm.password = $$v
                                                },
                                                expression: "password",
                                              },
                                            }),
                                            _c(
                                              "b-input-group-append",
                                              { attrs: { "is-text": "" } },
                                              [
                                                _c("feather-icon", {
                                                  staticClass: "cursor-pointer",
                                                  attrs: {
                                                    icon: _vm.showPassword
                                                      ? "EyeOffIcon"
                                                      : "EyeIcon",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.showPassword =
                                                        !_vm.showPassword
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Repeat Password" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                rules: "required|confirmed:password",
                                name: "Confirm Password",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "b-input-group",
                                          {
                                            staticClass: "input-group-merge",
                                            class:
                                              errors.length > 0
                                                ? "is-invalid"
                                                : null,
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: _vm.showConfirmPassword
                                                  ? "text"
                                                  : "password",
                                                state: errors[0] ? false : null,
                                                placeholder: "Repeat Password",
                                                autocomplete: "new-password",
                                              },
                                              model: {
                                                value: _vm.confirmPassword,
                                                callback: function ($$v) {
                                                  _vm.confirmPassword = $$v
                                                },
                                                expression: "confirmPassword",
                                              },
                                            }),
                                            _c(
                                              "b-input-group-append",
                                              { attrs: { "is-text": "" } },
                                              [
                                                _c("feather-icon", {
                                                  staticClass: "cursor-pointer",
                                                  attrs: {
                                                    icon: _vm.showConfirmPassword
                                                      ? "EyeOffIcon"
                                                      : "EyeIcon",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.showConfirmPassword =
                                                        !_vm.showConfirmPassword
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "mr-1",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: invalid,
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(" Submit "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }